const isObject = require('isobject');

export const currentSection = (props={}) => {
  const { form } = (props && props.submissionInfo) || {};
  const { section } = form || {};

  return section;
};

export const totalSections = (progressText={}) => {
  return (progressText && Object.keys(progressText).length) || 1;
};

const getCurrentAndTotalSections = (props= {}) => {
  const section = currentSection(props);
  const totalNumberOfSections = totalSections(props && props.progressText);

  return [ section, totalNumberOfSections ];
};

export const incrementSection = (section=1) => {
  return typeof section === "number" && section > 0? section+1 : 1;
};

export const decrementSection = (section=1) => {
  if (typeof section === "number" && section > 1) {
    return section-1;
  }

  return 1;
};

export const getNestedValue = (props, ...keys) => {
  if (!isObject(props)) {
    return "";
  }

  const keysLength = keys.length;
  const firstKey = keys.shift();
  const newProps = props[firstKey];

  if (keysLength > 1) {
    return getNestedValue(newProps, ...keys);
  }

  return newProps || "";
};

export const isFirstSection = (props={}) => {
  const section = currentSection(props);

  return section === 1;
};

export const isLastSection = (props={}) => {
  const [ section, totalNumberOfSections ] = getCurrentAndTotalSections(props);
  return section === totalNumberOfSections;
};

export const submissionSection = (props={}) => {
  if (!isObject(props)) {
    return 1;
  }

  const totalNumberOfSections= totalSections(props && props.progressText);
  return decrementSection(totalNumberOfSections);
};

export const isSubmissionSection = (props={}) => {
  return currentSection(props) === submissionSection(props);
};

export const nextSection = (props= {}) => {
  const [ section, totalNumberOfSections ] = getCurrentAndTotalSections(props);

  if (!isLastSection(props) && section < totalNumberOfSections) {
    return incrementSection(section);
  }

  return 1;
};

export const previousSection = (props= {}) => {
  const [ section, totalNumberOfSections ] = getCurrentAndTotalSections(props);

  return section <= totalNumberOfSections? decrementSection(section) : 1;
};
